// extracted by mini-css-extract-plugin
export default {"wrapper":"VirtualList_wrapper__6LCyX","inner":"VirtualList_inner__aXaoF","item":"VirtualList_item__Xv71R"};